// extracted by mini-css-extract-plugin
export var column = "_qz-0";
export var divider = "_qz-2";
export var timePicker = "_qz-1";